import Editor from '@monaco-editor/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Button from '../components/elements/Button/Button';
import Card from '../components/elements/Card/Card';
import AppStateCubit from '../state/blocs/AppStateCubit';
import CardsCubit from '../state/blocs/CardsCubit';
import { useBloc } from '../state/state';

const JsonCardEditor = () => {
    const { t } = useTranslation();
    const [cards, { setJson, updateCard }] = useBloc(CardsCubit);
    const [appState] = useBloc(AppStateCubit);
    const [localJson, setLocalJson] = useState<string>('{}');
    const [saveJson, setJsonSave] = useState<object>({});

    useEffect(() => {
        setLocalJson(JSON.stringify(cards.json, null, '\t'));
    }, [cards]);
    const onEditorChange = (newVal: any) => {
        let toSave;

        try {
            toSave = JSON.parse(newVal);
        } catch (e) {
            return;
        }

        setJsonSave(toSave);
    };

    const clickPreview = async () => {
        if (cards.cardId.length <= 3) {
            toast.warn('User id is empty');
            return;
        }

        setJson(saveJson);
    };

    const clickSave = async () => {
        if (cards.cardId.length <= 3) {
            toast.warn('User id is empty');
            return;
        }

        updateCard(cards.cardId, saveJson);
    };

    return (
        <Card noTitle>
            <Editor
                theme={appState.style === 'light' ? 'vs' : 'vs-dark'}
                onChange={onEditorChange}
                height="60vh"
                defaultLanguage="json"
                value={localJson}
                options={{
                    fontSize: 18,
                    folding: false,
                    lineNumbers: 'off',
                    formatOnPaste: true,
                    minimap: {
                        enabled: false,
                    },
                }}
            />
            <div className="grid">
                <div className="s3">
                    <Button color="primary" onClick={clickPreview} label={t('button.preview')} disabled={cards.cardId.length <= 3} />
                </div>
                <div className="space" />
                <div className="s3">
                    <Button color="secondary" onClick={clickSave} label={t('button.save')} disabled={cards.cardId.length <= 3} />
                </div>
            </div>
        </Card>
    );
};

export default JsonCardEditor;
